export const SOCIAL_PLATFORM_RATINGS_URL =
  "http://176.126.66.149:8081/widgets/ratings?widgetKey=social_platform_ratings";

/** Show when PAAM and/or Copy Trading is enabled. Hidden only when both flags are false. */
export function shouldShowPlatformRatingRoute(userDetails) {
  const pammEnabled = Boolean(userDetails?.isPammEnable);
  const copyEnabled = Boolean(userDetails?.isCopyTradingEnable);
  return pammEnabled || copyEnabled;
}
